module.exports = __webpack_public_path__ + "static/media/icon-sales-active-white.e295b6c5.svg";